import React, { useEffect } from 'react'
import { WarningOutlined } from '@ant-design/icons'
import { Row, Col, Progress, notification, Button } from 'antd'
import { use, app, api } from 'xadmin'
import moment from 'moment' 

const ChangePwdNotification = () => {
    const { user } = use('redux', state => ({ user: state.user }))
    const btn = (
        <div style={{ minWidth: '336px' }}>
            <Button type="primary" size="small" onClick={() => { app.go(`/pwdPage?id=${user?.userId}`) }}>去修改</Button>
        </div>
    )

    useEffect(() => {
        let userId = user?.userId
        api({ name: `core/user/${userId}` })
            .fetch('', {})
            .then(({ json }) => {
                if(json.pwdExpireConfig?.hasPwdExpire) {
                    const locaPathname = window.location.pathname
                    let pwdTimeouttime = localStorage.getItem(`${user.username}${locaPathname}pwdTimeouttime`)
                    if(pwdTimeouttime) {
                        let days = moment(moment(pwdTimeouttime)).diff(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), 'days')
                        if(days <= 2) {
                            notification.open({
                                message: <span><WarningOutlined /> 密码到期提醒</span>,
                                placement: 'bottomRight',
                                key: 'changePwd',
                                btn,
                                description: days >= 0 ? `密码在${moment(pwdTimeouttime).format('YYYY-MM-DD HH:mm:ss')}到期，请修改密码，否则会影响平台访问` : `密码即将到期，请修改密码，否则会影响平台访问`,
                                onClick: () => { }
                            })
                        }
                    }
                }
            })
    }, [ user?.userId ])
    return null
}

export default ChangePwdNotification